export const checkDateIsInSamePeriod = (chosenDate, period) => {
    const dateStr = period;
    const date = new Date(dateStr);
    const referenceDate = new Date(chosenDate);

    const isDateInCurrentPeriod = (referenceDate - date) / (1000 * 60 * 60 * 24) <= 6 && (referenceDate - date) >= 0;
    // console.log(chosenDate, period, isDateInCurrentPeriod, 'chosen date and period in new same week handler');
    return isDateInCurrentPeriod;
};
